export default "__VITE_ASSET__Br8tX1fH__"